import { Component, ViewChild } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { ResourceService } from '../../../../services/resources/resource.service';
import { ResourceEnvelope } from '../../../../models/net/envelope/resource-envelope';
import { ResourceType } from '../../../../models/data/talent-core/resource-type';
import { ResourceResourceType } from '../../../../models/data/talent-core/resource-resource-type';
import { EditorComponent } from '../../../base/editor/editor.component';
import { BlobService } from '../../../../services/blob/blob.service';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Citizenship } from '../../../../models/data/talent-core/citizenship';
import { AvatarPrimitive } from '../../../../models/app/avatar-primitive';
import { ChipSelectorComponent } from '../../../fragments/chip-selector/chip-selector.component';
import { ResourceDocument } from '../../../../models/net/envelope/documents/resource-document';
import { ResourceCitizenship } from '../../../../models/data/talent-core/resource-citizenship';
import { EngagementSearchResult } from '../../../../models/net/result/engagement-search-result';
import { Gender } from '../../../../models/data/talent-core/gender';
import { CharacterType } from '../../../../models/data/talent-core/character-type';
import { Ethnicity } from '../../../../models/data/talent-core/ethnicity';
import { ActingProfile } from '../../../../models/data/talent-core/acting-profile';
import { ActingProfileCharacterType } from '../../../../models/data/talent-core/acting-profile-character-type';
import { ActingProfileEthnicity } from '../../../../models/data/talent-core/acting-profile-ethnicity';
import { MatSelectChange } from '@angular/material/select';
import { MessageSeverity } from '../../../../enums/message-severity';
import { ActingProfileTileComponent } from '../../../fragments/talent-core/acting-profile-tile/acting-profile-tile.component';
import { LogoComponent } from '../../../fragments/logo/logo.component';
import { ActingProfileEnvelope } from '../../../../models/net/envelope/acting-profile-envelope';
import { EnvelopeFactory } from '../../../../utilities/envelope-factory';
import { ComponentDialogResult } from '../../../../models/app/component-dialog-result';
import { ActingProfileService } from '../../../../services/acting-profiles/acting-profile.service';
import { ItemEnvelope } from '../../../../models/net/envelope/base/item-envelope';
import { HttpErrorResponse } from '@angular/common/http';
import { Engagement } from '../../../../models/data/talent-core/engagement';
import { EngagementEnvelope } from '../../../../models/net/envelope/engagement-envelope';
import { EngagementTileComponent } from '../../../fragments/talent-core/engagement-tile/engagement-tile.component';
import { EngagementService } from '../../../../services/engagements/engagement.service';
import { ReadResult } from '../../../../models/net/result/crud/read-result';
import { ProductionRole } from '../../../../models/data/talent-core/production-role';
import { Resource } from '../../../../models/data/talent-core/resource';
import { Production } from '../../../../models/data/talent-core/production';
import { ProductionSearchResult } from '../../../../models/net/result/production-search-result';
import { EngagementStatus } from '../../../../models/data/talent-core/engagement-status';
import { ProductionService } from '../../../../services/productions/production.service';
import { DialogableEngagementEnvelope } from '../../../../models/app/dialogable-engagement-envelope';

@Component({
    selector: 'app-resource',
    templateUrl: './resource.component.html',
    styleUrls: ['./resource.component.css', '../../../../app.component.css']
})

export class ResourceComponent extends EditorComponent {

    public proformaEngagementEnvelope: EngagementEnvelope | undefined;
    public productionRolesCache: ProductionRole[] = [];
    public resourceEnvelope: ResourceEnvelope | undefined;
    public selectedResourceType: ResourceType | null = null;
    public resourceResourceTypesDatasource: any = null;
    public availableResourceTypes: AvatarPrimitive[] = [];
    public availableCitizenships: AvatarPrimitive[] = [];
    public avatarUrl: any;
    public isApiImage: string = 'false';
    public selectedResourceTypeIds: number[] = [];
    public selectedCitizenshipIds: number[] = [];
    public engagementsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as ResourceDocument).Engagements);
    public displayedEngagementsColumns = ["Avatar", "ProductionName", "RoleName", "EngagementStatus", "StartOnUTC", "Delete"];
    public isActor: boolean = false;
    public actorTabLabel: string = "The Actor";
    public availableActingProfiles: ActingProfile[] = [];
    public enteredProfileName: string = "";
    public enteredAgeRangeExpression: string = "";

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    @ViewChild("resourceTypeChipSelector") resourceTypeChipSelector!: ChipSelectorComponent;
    @ViewChild("citizenshipChipSelector") citizenshipChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: ResourceService,
                       public override route: ActivatedRoute,
                       public override location: Location,
                       public blobService: BlobService,
                       public actingProfileService: ActingProfileService,
                       public engagementService: EngagementService,
                       public productionService: ProductionService) {

        super(appService, itemService, route, location, "resource", "resources");
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        this.engagementService.getBlankEnvelope().subscribe((r: ItemEnvelope | null) => {

            if (r) {

                this.proformaEngagementEnvelope = r as EngagementEnvelope;
            }
        });
    }

    public ngAfterViewInit(): void {

        this.resourceTypeChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedResourceTypeIds.push(item.Id);
            this.addResourceTypeToResource(item.Id);
        });

        this.resourceTypeChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedResourceTypeIds.splice(this.selectedResourceTypeIds.indexOf(item.Id), 1);
            this.removeResourceTypeFromResource(item.Id);
        });

        this.citizenshipChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

            this.selectedCitizenshipIds.push(item.Id);
            this.addCitizenshipToResource(item.Id);
        });

        this.citizenshipChipSelector.itemRemoved.subscribe((item: AvatarPrimitive) => {

            this.selectedCitizenshipIds.splice(this.selectedCitizenshipIds.indexOf(item.Id), 1);
            this.removeCitizenshipFromResource(item.Id);
        });
    }

    public override initializeEnvelope = (envelope: ResourceEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        const productionRoleIds: number[] = envelope?.Document.Engagements.map((i: Engagement) => i.ProductionRoleId ?? 0) ?? [0];

        this.productionService.getProductionRolesByIds(productionRoleIds).subscribe((r: ProductionRole[] | null) => {

            if (r) {

                this.productionRolesCache = r;

                this.resourceEnvelope = new ResourceEnvelope(envelope);
                this.itemEnvelope = this.resourceEnvelope;
                this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);
                this.resourceResourceTypesDatasource = new MatTableDataSource((this.itemEnvelope as ResourceEnvelope).Document?.ResourceTypes);
                const resourceTypeIds: number[] = (this.itemEnvelope as ResourceEnvelope).Document?.ResourceTypes.map((i: ResourceResourceType) => i.ResourceTypeId);
                this.avatarUrl = envelope?.Document?.Person?.AvatarBlobPath == null ? this.appService.defaultImageUri : envelope.Document?.Person.AvatarBlobPath;
                this.isApiImage = envelope?.Document?.Person?.AvatarBlobPath == null ? 'false' : 'true';
                this.engagementsDatasource = new MatTableDataSource((this.itemEnvelope as ResourceEnvelope).Document?.Engagements);
                this.availableActingProfiles = (this.itemEnvelope?.Document as ResourceDocument).ActingProfiles;

                const availableResourceTypes: AvatarPrimitive[] = (this.itemEnvelope as ResourceEnvelope).ResourceTypes.map((i: ResourceType) => {
                    let result = new AvatarPrimitive();
                    result.Id = i.ResourceTypeId;
                    result.Name = i.UID;
                    result.AvatarBlobPath = this.appService.defaultImageUri;
                    return result;
                });

                const availableCitizenships: AvatarPrimitive[] = (this.itemEnvelope as ResourceEnvelope).Citizenships.map((i: Citizenship) => {
                    let result = new AvatarPrimitive();
                    result.Id = i.CitizenshipId;
                    result.Name = i.UID;
                    result.AvatarBlobPath = i.AvatarBlobPath;
                    return result;
                });

                this.availableResourceTypes = availableResourceTypes;
                this.availableCitizenships = availableCitizenships;

                this.selectedResourceTypeIds = (this.itemEnvelope?.Document as ResourceDocument).ResourceTypes.map(i => i.ResourceTypeId);
                this.selectedCitizenshipIds = (this.itemEnvelope?.Document as ResourceDocument).Citizenships.map(i => i.CitizenshipId);

                this.isActor = (this.itemEnvelope.Document as ResourceDocument).ResourceTypes.filter(i => i.ResourceTypeId == 1).length > 0

                const genderId = (this.itemEnvelope.Document as ResourceDocument).Item.GenderId;
                this.actorTabLabel = genderId != null && genderId == 2 ? "The Actress" : "The Actor";
            }
        });

    }

    public getResourceTypeUIDFromResourceTypeId = (resourceTypeId: number): string => {

        let result: string = "";

        let resourceType: ResourceType | undefined = (<ResourceEnvelope>this.itemEnvelope)?.ResourceTypes.find((i: ResourceType) => i.ResourceTypeId == resourceTypeId);

        if (resourceType) {

            result = resourceType.UID;
        }

        return result;
    }

    public addSelectedResourceTypeToResource = (): void => {

        const resourceResourceType: ResourceResourceType = {
            ResourceResourceTypeId: 0,
            ResourceId: (<ResourceEnvelope>this.itemEnvelope)?.Document?.Item?.ResourceId == null ? 0 : (<ResourceEnvelope>this.itemEnvelope)?.Document?.Item?.ResourceId,
            ResourceTypeId: this.selectedResourceType?.ResourceTypeId == null ? 0 : this.selectedResourceType?.ResourceTypeId,
            CreatedOnUTC: new Date(),
            CreateUserUID: ""
        };

        (<ResourceEnvelope>this.itemEnvelope)?.Document?.ResourceTypes.push(resourceResourceType);

        this.resourceResourceTypesDatasource = new MatTableDataSource((<ResourceEnvelope>this.itemEnvelope)?.Document?.ResourceTypes);

        const itemIndex: number = this.availableResourceTypes.map((i: any) => i.ResourceTypeId).indexOf(this.selectedResourceType?.ResourceTypeId, 0);

        if (itemIndex > -1) {

            this.availableResourceTypes.splice(itemIndex, 1);
        }

        this.selectedResourceType = null;

        this.isActor = (this.itemEnvelope?.Document as ResourceDocument).ResourceTypes.filter(i => i.ResourceTypeId == 1).length > 0
    }

    public editAvatar = (): void => {

        this.appService.showPendingFeatureDialog();
    }

    public onTabChange(event: MatTabChangeEvent) {

        if (event.index == 3 && !this.isRevisionListLoaded) {

            this.appHistory.searchRevisions();
        }
    }

    public addResourceTypeToResource = (resourceTypeId: number): void => {

        const document: ResourceDocument = (this.itemEnvelope?.Document as ResourceDocument);
        const newResourceResourceType: ResourceResourceType = new ResourceResourceType();

        newResourceResourceType.ResourceId = document.Item.ResourceId;
        newResourceResourceType.ResourceTypeId = resourceTypeId;

        document.ResourceTypes.push(newResourceResourceType);

        this.isActor = (this.itemEnvelope?.Document as ResourceDocument).ResourceTypes.filter(i => i.ResourceTypeId == 1).length > 0
    }

    public addCitizenshipToResource = (citizenshipId: number): void => {

        const document: ResourceDocument = (this.itemEnvelope?.Document as ResourceDocument);
        const newResourceCitizenship: ResourceCitizenship = new ResourceCitizenship();

        newResourceCitizenship.ResourceId = document.Item.ResourceId;
        newResourceCitizenship.CitizenshipId = citizenshipId;

        document.Citizenships.push(newResourceCitizenship);
    }

    public getAvatarBlobPathFromCitizenshipId = (citizenshipId: number): string | undefined => {

        let result: string | undefined = "";

        let citizenship: Citizenship | undefined = (this.itemEnvelope as ResourceEnvelope)?.Citizenships.find((i: Citizenship) => i.CitizenshipId == citizenshipId);

        if (citizenship) {

            result = citizenship.AvatarBlobPath;
        }

        return result;
    }

    public getCitizenshipNameFromCitizenshipId = (citizenshipId: number): string | undefined => {

        let result: string | undefined = "";

        let citizenship: Citizenship | undefined = (this.itemEnvelope as ResourceEnvelope)?.Citizenships.find((i: Citizenship) => i.CitizenshipId == citizenshipId);

        if (citizenship) {

            result = citizenship.UID;
        }

        return result;
    }

    public override ngDoCheck(): void {

        const genderId = (this.itemEnvelope?.Document as ResourceDocument).Item.GenderId;
        this.actorTabLabel = genderId != null && genderId == 2 ? "The Actress" : "The Actor";

        super.ngDoCheck();
    }

    public removeResourceTypeFromResource = (resourceTypeId: number): void => {

        const document: ResourceDocument = (this.itemEnvelope?.Document as ResourceDocument);

        const itemIndex: number | undefined = document.ResourceTypes.map((i: ResourceResourceType) => i.ResourceTypeId).indexOf(resourceTypeId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            document.ResourceTypes.splice(itemIndex, 1);
        }

        this.isActor = (this.itemEnvelope?.Document as ResourceDocument).ResourceTypes.filter(i => i.ResourceTypeId == 1).length > 0
    }

    public removeCitizenshipFromResource = (citizenshipId: number): void => {

        const document: ResourceDocument = (this.itemEnvelope?.Document as ResourceDocument);

        const itemIndex: number | undefined = document.Citizenships.map((i: ResourceCitizenship) => i.CitizenshipId).indexOf(citizenshipId, 0);

        if (itemIndex != undefined && itemIndex > -1) {

            document.Citizenships.splice(itemIndex, 1);
        }
    }

    public onAgeRangeKeyDown(event: KeyboardEvent) {

        if (event.key === '-') {

            const parts = this.enteredAgeRangeExpression.split('-');

            if (parts.length === 2) {

                this.enteredAgeRangeExpression = parts[0].replace(/_/g, "0").padStart(2, "0") + "-" + parts[1].replace(/_/g, "0").padStart(3, "0");

                event.preventDefault();
            }
        }
    }

    public onAgeRangeInputChange(event: Event) {

        const userInput: string = (event.target as HTMLInputElement).value;
        let maskExpression: string = "";

        const parts = userInput.split('-');

        if (parts.length === 2) {

            const part1 = parts[0].padStart(2, '0');
            const part2 = parts[1].padStart(3, '0');

            maskExpression = `${part1}-${part2}`;
        }

        this.enteredAgeRangeExpression = maskExpression;
    }

    public getGenderUIDFromGenderId = (genderId: number | undefined): string => {

        let result: string = "(undefined)";

        let gender: Gender | undefined = (this.itemEnvelope as ResourceEnvelope).Genders.find((i: Gender) => i.GenderId == genderId);

        if (gender) {

            result = gender.UID;
        }

        return result;
    }

    public getEthnicityUIDsFromActingProfileId = (actingProfileId: number | undefined): string => {

        let result: string = "(none)";

        const actingProfileEthnicities: ActingProfileEthnicity[] = (this.itemEnvelope?.Document as ResourceDocument).ProfileEthnicities.filter((i: ActingProfileEthnicity) => i.ActingProfileId == actingProfileId);

        if (actingProfileEthnicities && actingProfileEthnicities.length > 0) {

            const ethnicityIds: number[] = actingProfileEthnicities.map((i: ActingProfileEthnicity) => i.EthnicityId);
            const ethnicities: Ethnicity[] = (this.itemEnvelope as ResourceEnvelope).Ethnicities.filter((i: Ethnicity) => ethnicityIds.includes(i.EthnicityId));

            result = ethnicities.map((i: Ethnicity) => i.UID).join(", ");
        }

        return result;
    }

    public getCharacterTypeUIDsFromActingProfileId = (actingProfileId: number | undefined): string => {
            
        let result: string = "(none)";

        const actingProfileCharacterTypes: ActingProfileCharacterType[] = (this.itemEnvelope?.Document as ResourceDocument).ProfileCharacterTypes.filter((i: ActingProfileCharacterType) => i.ActingProfileId == actingProfileId);

        if (actingProfileCharacterTypes && actingProfileCharacterTypes.length > 0) {

            const characterTypeIds: number[] = actingProfileCharacterTypes.map((i: ActingProfileCharacterType) => i.CharacterTypeId);
            const characterTypes: CharacterType[] = (this.itemEnvelope as ResourceEnvelope).CharacterTypes.filter((i: CharacterType) => characterTypeIds.includes(i.CharacterTypeId));

            result = characterTypes.map((i: CharacterType) => i.UID).join(", ");
        }

        return result;
    }

    public showActingProfileDialog = (actingProfile: ActingProfile): void => {

        const actingProfileEnvelope: ActingProfileEnvelope = EnvelopeFactory.extractActingProfileEnvelope(actingProfile.ActingProfileId, (this.itemEnvelope as ResourceEnvelope), this.appService);
        const resourceFirstLastName: string = (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName;
        const dialogTitle: string = "Profile: " + resourceFirstLastName;
        const materialIconName: string = "theater_comedy";
 
        this.appService.showComponentDialog(ActingProfileTileComponent, actingProfileEnvelope, dialogTitle, "", materialIconName, undefined, undefined, false).subscribe((r: ComponentDialogResult | null) => {

            if (r) {

                if (r.IsAccepted) { // this means the user made a change and hit ok.  put the changes back into the item envelope 

                    this.itemEnvelope = EnvelopeFactory.mergeActingProfileToResourceEnvelope(r.DataSource, (this.itemEnvelope as ResourceEnvelope), this.appService);
                }
            }
        });
    }

    public addActingProfile = (): void => {

        this.appService.IsAppBusy = true;

        this.actingProfileService.getBlankEnvelope().subscribe((r: ItemEnvelope | null) => {

            if (r) {

                if (r instanceof HttpErrorResponse) {

                    this.appService.IsAppBusy = false;
                    this.appService.showDialog(MessageSeverity.Error, "Error Creating new Profile", "There was an error creating new profile for " + (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName + ".", "OK", "", true, true);

                } else {

                    this.appService.IsAppBusy = false;

                    // add proforma id to the new envelope and default the avatarblobpath to match the resource avatarblobpath
                    const actingProfileEnvelope: ActingProfileEnvelope = r as ActingProfileEnvelope;
                    const proformaActingProfileId: number = EnvelopeFactory.getProformaActingProfileId((this.itemEnvelope as ResourceEnvelope));

                    actingProfileEnvelope.Document.Item.ActingProfileId = proformaActingProfileId;
                    actingProfileEnvelope.Document.Item.ResourceId = (this.itemEnvelope?.Document as ResourceDocument).Item.ResourceId;
                    actingProfileEnvelope.Document.CharacterTypes.forEach((i: ActingProfileCharacterType) => i.ActingProfileId = proformaActingProfileId);
                    actingProfileEnvelope.Document.Ethnicities.forEach((i: ActingProfileEthnicity) => i.ActingProfileId = proformaActingProfileId);

                    const defaultAvatarBlobPath: string | undefined = (this.itemEnvelope?.Document as ResourceDocument).Item.AvatarBlobPath ?? (this.itemEnvelope?.Document as ResourceDocument).Person.AvatarBlobPath;
                    actingProfileEnvelope.Document.Item.AvatarBlobPath = defaultAvatarBlobPath;

                    const resourceFirstLastName: string = (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName;
                    const dialogTitle: string = "Profile: " + resourceFirstLastName;
                    const materialIconName: string = "theater_comedy";

                    this.appService.showComponentDialog(ActingProfileTileComponent, actingProfileEnvelope, dialogTitle, "", materialIconName, undefined, undefined, false).subscribe((r: ComponentDialogResult | null) => {

                        if (r) {

                            if (r.IsAccepted) {

                                this.itemEnvelope = EnvelopeFactory.mergeActingProfileToResourceEnvelope(r.DataSource, (this.itemEnvelope as ResourceEnvelope), this.appService);
                            }
                        }
                    });
                }
            }
        });
    }

    public deleteActingProfile = (actingProfile: ActingProfile): void => {

        const confirmResponse: string = "YES, I AM SURE";
        const actingProfilePersonName: string = (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName;

        this.appService.showDialog(MessageSeverity.Warning, "Confirm Deletion", "Are you sure you want to delete the acting profile " + actingProfile.Name + " for " + actingProfilePersonName + " ?", confirmResponse, "NO, NOT SURE", false, false).subscribe((r: string) => {

            if (r == confirmResponse) {

                this.itemEnvelope = EnvelopeFactory.removeActingProfileEnvelope(actingProfile, (this.itemEnvelope as ResourceEnvelope), this.appService);
                this.availableActingProfiles = (this.itemEnvelope?.Document as ResourceDocument).ActingProfiles;
            }
        });
    }

    public editEngagement = (engagement: Engagement): void => {

        this.engagementService.getBlankEnvelope().subscribe((r: ItemEnvelope | null) => { // need to go back to the database mainly for the engagement envelope lookup values

            if (r) {

                const proformaEngagementEnvelope: EngagementEnvelope = r as EngagementEnvelope;
                //const engagement: Engagement | undefined = (this.itemEnvelope!.Document as ResourceDocument).Engagements.find((i: Engagement) => i.EngagementId == engagement.EngagementId);

                if (engagement) { // this is the data source for the engagement that appears in the list of engagements

                    const engagementEnvelope: EngagementEnvelope = EnvelopeFactory.assembleEngagementEnvelope(engagement, proformaEngagementEnvelope, this.appService);
                    let dialogableEngagementEnvelope: DialogableEngagementEnvelope = Object.assign(new DialogableEngagementEnvelope(null), engagementEnvelope);
                    const resourceFirstLastName: string = (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName;

                    dialogableEngagementEnvelope.isResourceChipSelectorDisabled = true;

                    this.appService.showComponentDialog(EngagementTileComponent, dialogableEngagementEnvelope, "Edit Engagement: " + resourceFirstLastName, "", "cinematic_blur", undefined, undefined, false).subscribe((r: ComponentDialogResult | null) => {

                        if (r) {

                            if (r.IsAccepted) { // this means the user made a change and hit ok.  put the changes back into the item envelope

                                const productionRoleId: number | undefined = (r.DataSource as EngagementEnvelope).Document.Item.ProductionRoleId;
                                const isMissingProductionRoleLookup: boolean = !this.productionRolesCache.some((i: ProductionRole) => i.ProductionRoleId == productionRoleId);

                                // need to find out if the productionroleid (if any) is in the list of productionroles which are used by the grid to display names instead of numbers
                                if (productionRoleId && isMissingProductionRoleLookup) {

                                    this.productionService.getProductionRolesByIds([productionRoleId]).subscribe((productionRoles: ProductionRole[] | null) => {

                                        if (productionRoles) {

                                            this.productionRolesCache = this.productionRolesCache.concat(productionRoles); // build the look up list 
                                            this.itemEnvelope = EnvelopeFactory.mergeEngagementToResourceEnvelope(r.DataSource, (this.itemEnvelope as ResourceEnvelope));
                                            this.engagementsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as ResourceDocument).Engagements);
                                        }
                                    });

                                } else { // no need to buid up the production role lookup list

                                    this.itemEnvelope = EnvelopeFactory.mergeEngagementToResourceEnvelope(r.DataSource, (this.itemEnvelope as ResourceEnvelope));
                                    this.engagementsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as ResourceDocument).Engagements);
                                }
                            }
                        }
                    });
                }
            }
        });
    }

    public addEngagement = (): void => {

        this.engagementService.getBlankEnvelope().subscribe((r: ItemEnvelope | null) => { // need to go back to the database mainly for the engagement envelope lookup values

            if (r) {

                const proformaEngagementEnvelope: EngagementEnvelope = r as EngagementEnvelope;
                const engagement: Engagement = new Engagement();

                engagement.EngagementId = EnvelopeFactory.getProformaEngagementId((this.itemEnvelope as ResourceEnvelope).Document.Engagements);
                engagement.ResourceId = (this.itemEnvelope?.Document?.Item as Resource).ResourceId;

                if (engagement) { // this is the data source for the engagement that appears in the list of engagements

                    const engagementEnvelope: EngagementEnvelope = EnvelopeFactory.assembleEngagementEnvelope(engagement, proformaEngagementEnvelope, this.appService);
                    let dialogableEngagementEnvelope: DialogableEngagementEnvelope = Object.assign(new DialogableEngagementEnvelope(null), engagementEnvelope);
                    const resourceFirstLastName: string = (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName;
                    const dialogTitle: string = "New Engagement: " + resourceFirstLastName;
                    const materialIconName: string = "cinematic_blur";

                    dialogableEngagementEnvelope.isResourceChipSelectorDisabled = true;

                    this.appService.showComponentDialog(EngagementTileComponent, dialogableEngagementEnvelope, dialogTitle, "", materialIconName, undefined, undefined, false).subscribe((r: ComponentDialogResult | null) => {

                        if (r) {

                            if (r.IsAccepted) { // this means the user made a change and hit ok.  put the changes back into the item envelope

                                const productionRoleId: number | undefined = (r.DataSource as EngagementEnvelope).Document.Item.ProductionRoleId;
                                const isMissingProductionRoleLookup: boolean = !this.productionRolesCache.some((i: ProductionRole) => i.ProductionRoleId == productionRoleId);

                                // need to find out if the productionroleid (if any) is in the list of productionroles which are used by the grid to display names instead of numbers
                                if (productionRoleId && isMissingProductionRoleLookup) {

                                    this.productionService.getProductionRolesByIds([productionRoleId]).subscribe((productionRoles: ProductionRole[] | null) => {

                                        if (productionRoles) {

                                            this.productionRolesCache = this.productionRolesCache.concat(productionRoles); // build the look up list 
                                            this.itemEnvelope = EnvelopeFactory.mergeEngagementToResourceEnvelope(r.DataSource, (this.itemEnvelope as ResourceEnvelope));
                                            this.engagementsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as ResourceDocument).Engagements);
                                        }
                                    });

                                } else { // merge without roles

                                    this.itemEnvelope = EnvelopeFactory.mergeEngagementToResourceEnvelope(r.DataSource, (this.itemEnvelope as ResourceEnvelope));
                                    this.engagementsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as ResourceDocument).Engagements);
                                }
                            }
                        }
                    });
                }
            }
        });
    }

    public deleteEngagement = (engagement: Engagement): void => {

        const confirmResponse: string = "YES, I AM SURE";
        const engagementPersonName: string = (this.itemEnvelope?.Document as ResourceDocument).Person.FirstName + " " + (this.itemEnvelope?.Document as ResourceDocument).Person.LastName;

        this.appService.showDialog(MessageSeverity.Warning, "Confirm Deletion", "Are you sure you want to delete the engagement for  " + engagementPersonName + " ?", confirmResponse, "NO, NOT SURE", false, false).subscribe((r: string) => {

            if (r == confirmResponse) {

                this.itemEnvelope = EnvelopeFactory.removeEngagementFromResource(engagement, (this.itemEnvelope as ResourceEnvelope), this.appService);
                this.engagementsDatasource = new MatTableDataSource((this.itemEnvelope?.Document as ResourceDocument).Engagements);
            }
        });
    }

    public getProductionNameFromEngagement = (engagement: Engagement): string => {

        let result: string = this.proformaEngagementEnvelope?.AvailableProductions.find((i: ProductionSearchResult) => i.ProductionId == engagement.ProductionId)?.Name ?? "";

        return result;
    }

    public getProductionAvatarBlobPathFromEngagement = (engagement: Engagement): string => {

        let result: string = this.proformaEngagementEnvelope?.AvailableProductions.find((i: ProductionSearchResult) => i.ProductionId == engagement.ProductionId)?.AvatarBlobPath ?? this.appService.defaultImageUri;

        return result;
    }

    public getProductionRoleNameFromEngagement = (engagement: Engagement): string => {

        let result: string = this.productionRolesCache.find((i: ProductionRole) => i.ProductionRoleId == engagement.ProductionRoleId)?.Name ?? "";

        return result;
    }

    public getEngagementStatusNameFromEngagement = (engagement: Engagement): string => {

        let result: string = this.proformaEngagementEnvelope?.EngagementStatuses.find((i: EngagementStatus) => i.EngagementStatusId == engagement.EngagementStatusId)?.UID ?? "";

        return result;
    }
}
